import styled from "@emotion/native";
import Text from "../../components/Text";
import { Dimensions, Platform } from "react-native";

const { height } = Dimensions.get("window");
export const StackContainer = styled.View(
	{
		flex: 1,
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.background,
		};
	}
);

export const Background = styled.Image({
	position: "absolute",
	width: "100%",
	height: "100%",
	resizeMode: "cover",
});

export const Container = styled.View({
	flex: 1,
	backgroundColor: "transparent",
});

export const Scroll = styled.ScrollView({
	flex: 1,
	marginTop: height * 0.13,
	overflow: Platform.OS === "android" ? "scroll" : "visible",
	backgroundColor: "transparent",
});

export const Title = styled(Text)({
	paddingHorizontal: 13,
	marginBottom: 10,
});

export const ResourceCategoryList = styled.View({
	paddingHorizontal: 12,
});
